import { forwardRef } from "react";
import styles from "./infodialog.module.css";


const InfoDialog = forwardRef(function InputDialog(props, ref) {

  return (
    <dialog ref={ref} className={styles.Dialog}>
      <div className={styles.Header}>
        <img className={styles.Close} onClick={props.closeDialog} src='/icons/close-blue.svg'></img><br/>
      </div>
      
      <div className={styles.Body}>
        <div className={styles.Title}>{props.dialogTitle}</div>
        <div className={styles.Text}>{props.dialogMessage}</div>
      </div>
    </dialog>
  )
})

export default InfoDialog;